import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "./app/store";
import { ToastContainer } from "./components/common/Toast/ToastContainer";
import { router } from "./routes/routes";
import "./styles/global.css";

function App() {
	return (
		<div className="flex h-full min-h-0 w-full flex-col overflow-hidden">
			<Provider store={store}>
				<div className="flex min-h-0 flex-1 flex-col overflow-hidden">
					<RouterProvider router={router} />
				</div>
				<ToastContainer />
			</Provider>
		</div>
	);
}

export default App;
